import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { UsersPage } from "./users.page";

const routes: Routes = [
  {
    path: "",
    component: UsersPage,
  },
  {
    path: "add",
    loadChildren: () =>
      import("./edit-user/edit-user.module").then((m) => m.EditUserPageModule),
      data: {
        breadcrumb: 'USERS.NEW_USER'
      },
  },
  {
    path: "edit/:UserId",
    loadChildren: () =>
      import("./edit-user/edit-user.module").then((m) => m.EditUserPageModule),
      data: {
        breadcrumb: 'USERS.EDIT_USER'
      },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UsersPageRoutingModule {}
